import { render, staticRenderFns } from "./Talonario.vue?vue&type=template&id=81aceefa"
import script from "./Talonario.vue?vue&type=script&lang=js"
export * from "./Talonario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports